"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FileUploader_1 = require("./FileUploader");
Object.defineProperty(exports, "FileUploader", { enumerable: true, get: function () { return FileUploader_1.FileUploader; } });
//# sourceMappingURL=index.js.map